import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./lib/AuthContext";
import Layout from "./components/layout/Layout";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQs from "./pages/FAQs";
import Resources from "./pages/Resources";
import AccidentTypes from "./pages/AccidentTypes";
import AccidentTypeDetail from "./pages/AccidentTypeDetail";
import IndianaCities from "./pages/IndianaCities";
import IndianaCityDetail from "./pages/IndianaCityDetail";
import Blog from "./pages/Blog";
import BlogPostPage from "./pages/BlogPost";
import NotFound from "./pages/NotFound";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Disclaimer from "./pages/Disclaimer";
import AuthorProfile from "./pages/AuthorProfile";
import EditorialPolicy from "./pages/EditorialPolicy";
import Corrections from "./pages/Corrections";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import LeadsPage from "./pages/admin/LeadsPage";
import { BlogManager, CityManager, AccidentTypeManager, FAQManager, TestimonialManager } from "./pages/admin/managers";
import ContentStrategy from "./pages/admin/ContentStrategy";
import Calendar from "./pages/admin/Calendar";
import Exports from "./pages/admin/Exports";
import SeoTools from "./pages/admin/SeoTools";
import SiteVerification from "./components/SiteVerification";
import AnalyticsRouteTracker from "./components/AnalyticsRouteTracker";

const wrap = (Component) => (
  <Layout>
    <Component />
  </Layout>
);

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <SiteVerification />
            <AnalyticsRouteTracker />
            <Routes>
              {/* Public */}
              <Route path="/" element={wrap(Home)} />
              <Route path="/about" element={wrap(About)} />
              <Route path="/contact" element={wrap(Contact)} />
              <Route path="/faqs" element={wrap(FAQs)} />
              <Route path="/resources" element={wrap(Resources)} />
              <Route path="/privacy" element={wrap(Privacy)} />
              <Route path="/terms" element={wrap(Terms)} />
              <Route path="/disclaimer" element={wrap(Disclaimer)} />
              <Route path="/accident-types" element={wrap(AccidentTypes)} />
              <Route path="/accident-types/:slug" element={wrap(AccidentTypeDetail)} />
              <Route path="/indiana-cities" element={wrap(IndianaCities)} />
              <Route path="/indiana-cities/:slug" element={wrap(IndianaCityDetail)} />
              <Route path="/blog" element={wrap(Blog)} />
              <Route path="/blog/:slug" element={wrap(BlogPostPage)} />
              <Route path="/authors/:slug" element={wrap(AuthorProfile)} />
              <Route path="/editorial-policy" element={wrap(EditorialPolicy)} />
              <Route path="/corrections" element={wrap(Corrections)} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<LeadsPage />} />
                <Route path="content-strategy" element={<ContentStrategy />} />
                <Route path="calendar" element={<Calendar />} />
                <Route path="blog" element={<BlogManager />} />
                <Route path="cities" element={<CityManager />} />
                <Route path="accident-types" element={<AccidentTypeManager />} />
                <Route path="faqs" element={<FAQManager />} />
                <Route path="testimonials" element={<TestimonialManager />} />
                <Route path="exports" element={<Exports />} />
                <Route path="seo-tools" element={<SeoTools />} />
              </Route>

              <Route path="*" element={wrap(NotFound)} />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
